import React, {useState} from 'react';
import IconTextView, {INPUT_TYPE} from "../../../components/input/IconTextView";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import CustomCheckBox from "components/checkBox/CustomCheckBox";
import {useHistory} from "react-router-dom";
import {getButtonHeight, getTextViewHeight, IsF, IsM, IsSM, IsT} from "my-styles/media/media";
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import messages from "res/messages/farsi";

import ICArrowBackIosIcon from "res/images/left_arrow.png";
import ICInvite from "res/images/title.png";
import ICPhone from "res/images/phone.png";
import ICFantasticBg1 from "res/images/fantastic_bg_1.png";
import ICFantasticBg2 from "res/images/fantastic_bg_2.png";
import ICLoginPhone from "res/images/login_phone.png";

export default function Login(props) {

    const history = useHistory()

    const [agreementCheckedStatus, setAgreementCheckedStatus] = useState(true)
    const [telephone, setTelephone] = useState("")
    const [invitedCode, setInvitedCode] = useState("")

    function checkLogin() {
        if (agreementCheckedStatus) {
            requestLogin()
        } else {
            props.onAlert(messages.pleaseCheckAggrement)
        }
    }

    function requestLogin() {
        if (telephone) {
            authenticationViewModel.login(telephone,
                () => {
                    props.onNavigate(history, "/verify",
                        {invitedCode: invitedCode, telephone: telephone})
                },
                (data) => {
                    let message = messages.sendVerifyCodeError
                    if (data !== undefined && data.description !== undefined) {
                        if (data.description === 103) {
                            message = messages.wrongPhoneNumber
                        }
                        if (data.description === 104) {
                            message = messages.timeVerifyCodeError
                        }
                    }
                    props.onAlert(message)
                }, () => {
                    props.onLoading(true)
                }, () => {
                    props.onLoading(false)
                }
            )
        } else {
            props.onAlert(messages.enterTelephone)
        }
    }

    return (IsSM() || IsM() ?
        <div className="marginSmall" style={{
            backgroundImage: 'url(' + ICFantasticBg2 + ')',
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}>
            <table className="fullWidth center" style={{height: "35em"}}>
                <tbody>
                <tr>
                    <td>
                        <center>
                            <div style={{width: "60%"}}>
                                <IconTextView
                                    type={INPUT_TYPE.PHONE_NUMBER}
                                    height={getTextViewHeight()}
                                    placeholder={messages.telephone}
                                    maxlength="11"
                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setTelephone(e.target.value)
                                    }}
                                    onEnterClick={() => {
                                        checkLogin()
                                    }}/>
                            </div>
                            <div style={{width: "60%"}}>
                                <IconTextView
                                    type={INPUT_TYPE.NUMBER}
                                    height={getTextViewHeight()}
                                    placeholder={messages.inviteCode}
                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICInvite} className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setInvitedCode(e.target.value)
                                    }}
                                    onEnterClick={() => {
                                        checkLogin()
                                    }}/>
                            </div>
                            <div style={{width: "80%"}} className="mediumTextBold">
                                <CustomCheckBox
                                    checked={agreementCheckedStatus}
                                    onClick={() => {
                                        setAgreementCheckedStatus(!agreementCheckedStatus)
                                    }}/>
                                <label className="clickable" style={{color: "var(--blue_3)"}}
                                       onClick={() => {
                                           props.onNavigate(history, '/aggrement')
                                       }}>
                                    {messages.roleAndCondition}
                                </label>
                                <label>
                                    {messages.readAndAccept}
                                </label>
                            </div>
                            <div style={{marginTop: "3em", width: "60%"}}>
                                <IconTitleButtonRound
                                    height={getButtonHeight()}
                                    fontSize="mediumTextBold"
                                    onClick={() => {
                                        if (agreementCheckedStatus) {
                                            requestLogin()
                                        } else {
                                            props.onAlert(messages.pleaseCheckAggrement)
                                        }
                                    }}
                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICArrowBackIosIcon} className="marginSmall xSmallIcon"/>}
                                    title={messages.enter}/>
                            </div>
                        </center>
                    </td>
                </tr>
                </tbody>
            </table>
        </div> :
        IsF() ?
            <div className="marginSmall" style={{
                backgroundImage: 'url(' + ICFantasticBg2 + ')',
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}>
                <table className="fullWidth center" style={{height: "35em"}}>
                    <tbody>
                    <tr>
                        <td>
                            <center>
                                <div style={{width: "55%"}}>
                                    <IconTextView
                                        type={INPUT_TYPE.PHONE_NUMBER}
                                        height={getTextViewHeight()}
                                        placeholder={messages.telephone}
                                        maxlength="11"
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setTelephone(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            checkLogin()
                                        }}/>
                                </div>
                                <div style={{width: "55%"}}>
                                    <IconTextView
                                        type={INPUT_TYPE.NUMBER}
                                        height={getTextViewHeight()}
                                        placeholder={messages.inviteCode}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICInvite} className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setInvitedCode(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            checkLogin()
                                        }}/>
                                </div>
                                <div style={{width: "55%"}} className="mediumTextBold">
                                    <CustomCheckBox
                                        checked={agreementCheckedStatus}
                                        onClick={() => {
                                            setAgreementCheckedStatus(!agreementCheckedStatus)
                                        }}/>
                                    <label className="clickable" style={{color: "var(--blue_3)"}}
                                           onClick={() => {
                                               props.onNavigate(history, '/aggrement')
                                           }}>
                                        {messages.roleAndCondition}
                                    </label>
                                    <label>
                                        {messages.readAndAccept}
                                    </label>
                                </div>
                                <div style={{marginTop: "3em", width: "55%"}}>
                                    <IconTitleButtonRound
                                        height={getButtonHeight()}
                                        fontSize="mediumTextBold"
                                        onClick={() => {
                                            if (agreementCheckedStatus) {
                                                requestLogin()
                                            } else {
                                                props.onAlert(messages.pleaseCheckAggrement)
                                            }
                                        }}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICArrowBackIosIcon}
                                                   className="marginSmall xSmallIcon"/>}
                                        title={messages.enter}/>
                                </div>
                            </center>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div> :
            IsT() ?
                <div className="marginSmall" style={{
                    backgroundImage: 'url(' + ICFantasticBg2 + ')',
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>
                    <tbody>
                    <table className="fullWidth center" style={{height: "35em"}}>
                        <tbody>
                        <tr>
                            <td>
                                <center>
                                    <div style={{width: "40%"}}>
                                        <IconTextView
                                            type={INPUT_TYPE.PHONE_NUMBER}
                                            height={getTextViewHeight()}
                                            placeholder={messages.telephone}
                                            maxlength="11"
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setTelephone(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                checkLogin()
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        <IconTextView
                                            type={INPUT_TYPE.NUMBER}
                                            height={getTextViewHeight()}
                                            placeholder={messages.inviteCode}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICInvite} className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setInvitedCode(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                checkLogin()
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}} className="mediumTextBold">
                                        <CustomCheckBox
                                            checked={agreementCheckedStatus}
                                            onClick={() => {
                                                setAgreementCheckedStatus(!agreementCheckedStatus)
                                            }}/>
                                        <label className="clickable" style={{color: "var(--blue_3)"}}
                                               onClick={() => {
                                                   props.onNavigate(history, '/aggrement')
                                               }}>
                                            {messages.roleAndCondition}
                                        </label>
                                        <label>
                                            {messages.readAndAccept}
                                        </label>
                                    </div>
                                    <div style={{marginTop: "3em", width: "40%"}}>
                                        <IconTitleButtonRound
                                            height={getButtonHeight()}
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                if (agreementCheckedStatus) {
                                                    requestLogin()
                                                } else {
                                                    props.onAlert(messages.pleaseCheckAggrement)
                                                }
                                            }}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICArrowBackIosIcon}
                                                       className="marginSmall xSmallIcon"/>}
                                            title={messages.enter}/>
                                    </div>
                                </center>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </tbody>
                </div> :
                <div className="horizontalFullScreen">
                    <div className="formContainer">
                        <table className="background full" style={{backgroundImage: 'url(' + ICFantasticBg2 + ')'}}>
                            <tbody>
                            <tr>
                                <td>
                                    <center>
                                        <div className="halfWidth">
                                            <IconTextView
                                                type={INPUT_TYPE.PHONE_NUMBER}
                                                height={getTextViewHeight()}
                                                placeholder={messages.telephone}
                                                maxlength="11"
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setTelephone(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    checkLogin()
                                                }}/>
                                        </div>
                                        <div className="halfWidth">
                                            <IconTextView
                                                type={INPUT_TYPE.NUMBER}
                                                height={getTextViewHeight()}
                                                placeholder={messages.inviteCode}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICInvite} className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setInvitedCode(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    checkLogin()
                                                }}/>
                                        </div>
                                        <div className="twoFromThree mediumTextBold">
                                            <CustomCheckBox
                                                checked={agreementCheckedStatus}
                                                onClick={() => {
                                                    setAgreementCheckedStatus(!agreementCheckedStatus)
                                                }}/>
                                            <label className="clickable" style={{color: "var(--blue_3)"}}
                                                   onClick={() => {
                                                       props.onNavigate(history, '/aggrement')
                                                   }}>
                                                {messages.roleAndCondition}
                                            </label>
                                            <label>
                                                {messages.readAndAccept}
                                            </label>
                                        </div>
                                        <div className="halfWidth" style={{marginTop: "3em"}}>
                                            <IconTitleButtonRound
                                                height={getButtonHeight()}
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    checkLogin()
                                                }}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICArrowBackIosIcon}
                                                           className="marginSmall xSmallIcon"/>}
                                                title={messages.enter}/>
                                        </div>
                                    </center>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="imageContainer">
                        <img className="leftSideBg" src={ICFantasticBg1} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                        <img className="leftSideIcon" src={ICLoginPhone} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} />
                    </div>
                </div>)

}

//
// import React, { useState, useEffect } from 'react';
// import { Phone, Gift, ChevronLeft, Check, Shield, Sparkles, Users, Award } from 'lucide-react';
//
// const Login = ({ onNavigate, onAlert, onLoading }) => {
//     const [agreementChecked, setAgreementChecked] = useState(true);
//     const [telephone, setTelephone] = useState("");
//     const [inviteCode, setInviteCode] = useState("");
//     const [isLoading, setIsLoading] = useState(false);
//     const [focusedInput, setFocusedInput] = useState(null);
//
//     const messages = {
//         telephone: "Ø´ÙØ§Ø±Ù ØªÙÙÙ",
//         inviteCode: "Ú©Ø¯ Ø¯Ø¹ÙØª (Ø§Ø®ØªÛØ§Ø±Û)",
//         roleAndCondition: "ÙÙØ§ÙÛÙ Ù ÙÙØ±Ø±Ø§Øª",
//         readAndAccept: " Ø±Ø§ ÙÛâÙ¾Ø°ÛØ±Ù",
//         enter: "ÙØ±ÙØ¯",
//         pleaseCheckAggrement: "ÙØ·ÙØ§Ù ÙÙØ§ÙÛÙ Ù ÙÙØ±Ø±Ø§Øª Ø±Ø§ ØªØ£ÛÛØ¯ Ú©ÙÛØ¯",
//         enterTelephone: "ÙØ·ÙØ§Ù Ø´ÙØ§Ø±Ù ØªÙÙÙ Ø®ÙØ¯ Ø±Ø§ ÙØ§Ø±Ø¯ Ú©ÙÛØ¯",
//         appTitle: "ØµØ±ÙÙ ÙØ§Ø±Ú©Øª",
//         welcomeTitle: "Ø®ÙØ´ Ø¢ÙØ¯ÛØ¯"
//     };
//
//     const handleLogin = async () => {
//         if (!agreementChecked) {
//             onAlert && onAlert(messages.pleaseCheckAggrement);
//             return;
//         }
//
//         if (!telephone.trim()) {
//             onAlert && onAlert(messages.enterTelephone);
//             return;
//         }
//
//         setIsLoading(true);
//         onLoading && onLoading(true);
//
//         try {
//             await new Promise(resolve => setTimeout(resolve, 1500));
//             onNavigate && onNavigate("/verify", { inviteCode, telephone });
//         } catch (error) {
//             onAlert && onAlert("Ø®Ø·Ø§ Ø¯Ø± Ø§Ø±Ø³Ø§Ù Ú©Ø¯ ØªØ§ÛÛØ¯");
//         } finally {
//             setIsLoading(false);
//             onLoading && onLoading(false);
//         }
//     };
//
//     const handleKeyPress = (e) => {
//         if (e.key === 'Enter') {
//             handleLogin();
//         }
//     };
//
//     return (
//         <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex items-center justify-center p-4 relative overflow-hidden">
//             {/* Subtle background effects */}
//             <div className="absolute inset-0">
//                 <div className="absolute top-20 left-20 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse" />
//                 <div className="absolute bottom-20 right-20 w-80 h-80 bg-orange-500/10 rounded-full blur-3xl animate-pulse delay-1000" />
//             </div>
//
//             <div className="w-full max-w-5xl mx-auto grid lg:grid-cols-5 gap-8 items-center relative z-10">
//
//                 {/* Left side - Quick Info (Hidden on mobile) */}
//                 <div className="hidden lg:block lg:col-span-2">
//                     <div className="text-white space-y-8">
//                         <div>
//                             <h1 className="text-4xl font-bold bg-gradient-to-r from-white to-orange-200 bg-clip-text text-transparent mb-3">
//                                 {messages.appTitle}
//                             </h1>
//                             <p className="text-xl text-gray-300">ØªØ¬Ø±Ø¨Ù Ø®Ø±ÛØ¯ ÙÙØ´ÙÙØ¯</p>
//                         </div>
//
//                         <div className="space-y-4">
//                             <div className="flex items-center space-x-3 space-x-reverse">
//                                 <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-orange-500 rounded-xl flex items-center justify-center">
//                                     <Sparkles className="w-6 h-6 text-white" />
//                                 </div>
//                                 <div>
//                                     <h3 className="font-semibold text-lg">ØªØ®ÙÛÙâÙØ§Û ÙÛÚÙ</h3>
//                                     <p className="text-gray-400">ØªØ§ Û·Û°Ùª ØªØ®ÙÛÙ ÙØ­ØµÙÙØ§Øª</p>
//                                 </div>
//                             </div>
//
//                             <div className="flex items-center space-x-3 space-x-reverse">
//                                 <div className="w-12 h-12 bg-gradient-to-r from-slate-700 to-blue-600 rounded-xl flex items-center justify-center">
//                                     <Shield className="w-6 h-6 text-white" />
//                                 </div>
//                                 <div>
//                                     <h3 className="font-semibold text-lg">Ø®Ø±ÛØ¯ Ø§ÙÙ</h3>
//                                     <p className="text-gray-400">Û±Û°Û°Ùª Ø§ÙÙÛØª ØªØ±Ø§Ú©ÙØ´</p>
//                                 </div>
//                             </div>
//
//                             <div className="flex items-center space-x-3 space-x-reverse">
//                                 <div className="w-12 h-12 bg-gradient-to-r from-orange-600 to-slate-700 rounded-xl flex items-center justify-center">
//                                     <Users className="w-6 h-6 text-white" />
//                                 </div>
//                                 <div>
//                                     <h3 className="font-semibold text-lg">Ø¬Ø§ÙØ¹Ù Ø¨Ø²Ø±Ú¯</h3>
//                                     <p className="text-gray-400">Ø¨ÛØ´ Ø§Ø² Û±Û°Û° ÙØ²Ø§Ø± Ú©Ø§Ø±Ø¨Ø±</p>
//                                 </div>
//                             </div>
//                         </div>
//
//                         <div className="flex items-center justify-center lg:justify-start space-x-4 space-x-reverse pt-6 border-t border-white/10">
//                             <Award className="w-8 h-8 text-orange-400" />
//                             <span className="text-gray-300">Ø¨Ø±ØªØ±ÛÙ Ø¨Ø±ÙØ¯ Ø³Ø§Ù Û±Û´Û°Û³</span>
//                         </div>
//                     </div>
//                 </div>
//
//                 {/* Right side - Compact Login Form */}
//                 <div className="lg:col-span-3">
//                     <div className="w-full max-w-md mx-auto">
//                         {/* Mobile header */}
//                         <div className="lg:hidden text-center mb-8">
//                             <h1 className="text-3xl font-bold bg-gradient-to-r from-white to-orange-200 bg-clip-text text-transparent mb-2">
//                                 {messages.appTitle}
//                             </h1>
//                             <p className="text-gray-300">{messages.welcomeTitle}</p>
//                         </div>
//
//                         {/* Form container */}
//                         <div className="relative group">
//                             <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-orange-600 rounded-2xl blur opacity-20 group-hover:opacity-30 transition duration-300" />
//
//                             <div className="relative bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-8 shadow-xl">
//                                 <div className="space-y-6">
//
//                                     {/* Phone input */}
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-200 mb-2">
//                                             {messages.telephone} <span className="text-red-400">*</span>
//                                         </label>
//                                         <div className="relative">
//                                             <Phone className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 transition-colors ${focusedInput === 'phone' ? 'text-blue-400' : 'text-gray-400'}`} />
//                                             <input
//                                                 type="tel"
//                                                 value={telephone}
//                                                 onChange={(e) => setTelephone(e.target.value)}
//                                                 onFocus={() => setFocusedInput('phone')}
//                                                 onBlur={() => setFocusedInput(null)}
//                                                 onKeyPress={handleKeyPress}
//                                                 maxLength="11"
//                                                 placeholder="09123456789"
//                                                 className="w-full pl-10 pr-4 py-3 bg-white/5 border border-gray-600/50 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-200"
//                                                 dir="ltr"
//                                             />
//                                         </div>
//                                     </div>
//
//                                     {/* Invite code input */}
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-200 mb-2">
//                                             {messages.inviteCode}
//                                         </label>
//                                         <div className="relative">
//                                             <Gift className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 transition-colors ${focusedInput === 'invite' ? 'text-orange-400' : 'text-gray-400'}`} />
//                                             <input
//                                                 type="text"
//                                                 value={inviteCode}
//                                                 onChange={(e) => setInviteCode(e.target.value)}
//                                                 onFocus={() => setFocusedInput('invite')}
//                                                 onBlur={() => setFocusedInput(null)}
//                                                 onKeyPress={handleKeyPress}
//                                                 placeholder="Ú©Ø¯ Ø¯Ø¹ÙØª"
//                                                 className="w-full pl-10 pr-4 py-3 bg-white/5 border border-gray-600/50 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-200"
//                                             />
//                                         </div>
//                                     </div>
//
//                                     {/* Agreement */}
//                                     <div className="flex items-start space-x-3 space-x-reverse">
//                                         <button
//                                             onClick={() => setAgreementChecked(!agreementChecked)}
//                                             className={`flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200 mt-0.5 ${
//                                                 agreementChecked
//                                                     ? 'bg-blue-600 border-blue-600 text-white'
//                                                     : 'border-gray-400 hover:border-gray-300'
//                                             }`}
//                                         >
//                                             {agreementChecked && <Check className="w-3 h-3" />}
//                                         </button>
//                                         <div className="text-sm text-gray-300 leading-relaxed">
//                                             <button
//                                                 onClick={() => onNavigate && onNavigate('/agreement')}
//                                                 className="text-blue-400 hover:text-blue-300 underline-offset-2 hover:underline"
//                                             >
//                                                 {messages.roleAndCondition}
//                                             </button>
//                                             <span>{messages.readAndAccept}</span>
//                                         </div>
//                                     </div>
//
//                                     {/* Login button */}
//                                     <button
//                                         onClick={handleLogin}
//                                         disabled={isLoading}
//                                         className="w-full bg-gradient-to-r from-blue-600 to-orange-600 hover:from-blue-700 hover:to-orange-700 text-white font-semibold py-3.5 px-6 rounded-xl transition-all duration-200 transform hover:scale-[1.02] shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center space-x-2 space-x-reverse"
//                                     >
//                                         {isLoading ? (
//                                             <>
//                                                 <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
//                                                 <span>Ø¯Ø± Ø­Ø§Ù ÙØ±ÙØ¯...</span>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <span>{messages.enter}</span>
//                                                 <ChevronLeft className="w-5 h-5" />
//                                             </>
//                                         )}
//                                     </button>
//                                 </div>
//
//                                 {/* Footer */}
//                                 <div className="mt-6 text-center">
//                                     <p className="text-xs text-gray-400">
//                                         Ø¨Ø§ ÙØ±ÙØ¯Ø
//                                         <button
//                                             onClick={() => onNavigate && onNavigate('/privacy')}
//                                             className="text-orange-400 hover:underline mx-1"
//                                         >
//                                             Ø­Ø±ÛÙ Ø®ØµÙØµÛ
//                                         </button>
//                                         Ø±Ø§ ÙÛâÙ¾Ø°ÛØ±ÛØ¯
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//
//                         {/* Mobile features */}
//                         <div className="lg:hidden grid grid-cols-2 gap-4 mt-8 text-center">
//                             <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
//                                 <Sparkles className="w-8 h-8 text-orange-400 mx-auto mb-2" />
//                                 <p className="text-sm text-gray-300">ØªØ®ÙÛÙ ÙÛÚÙ</p>
//                             </div>
//                             <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
//                                 <Shield className="w-8 h-8 text-blue-400 mx-auto mb-2" />
//                                 <p className="text-sm text-gray-300">Ø®Ø±ÛØ¯ Ø§ÙÙ</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default Login;